var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CInput, {
    staticClass: "c-datepicker-wrapper",
    attrs: {
      id: _vm.id,
      type: "date",
      label: _vm.label,
      "input-class": _vm.inputClass,
      "label-class": _vm.labelClass,
      "input-size": _vm.inputSize,
      disabled: _vm.disabled,
      placeholder: _vm.placeholder,
      required: _vm.required,
      min: _setup.minValue,
      max: _setup.maxValue,
      error: _vm.error,
      "error-msg": _vm.errorMsg,
    },
    model: {
      value: _setup.model,
      callback: function ($$v) {
        _setup.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }